// extracted by mini-css-extract-plugin
export default {"buttonText":"DownloadExcelButton_buttonText__GKvod"};